import {I18n} from '@aws-amplify/core';

import {formatTimestamp} from '../../../utils/TableTimestamps';
import {NavLink} from 'react-router-dom';
import {IReportRunTableColumn, ReportRun} from '../types';

export const getColumns = (): IReportRunTableColumn[] => [
    {
        title: I18n.get('Report Type'),
        width: '1fr',
        render: (item: ReportRun) => <NavLink to={`/report-runs/${item.id}`}>{item.reportType}</NavLink>,
    },
    {
        title: I18n.get('Status'),
        width: '1fr',
        render: (item: ReportRun) => <>{item.status}</>,
    },
    {
        title: I18n.get('Created'),
        width: '1fr',
        render: (item: ReportRun) => <>{formatTimestamp(item.created as unknown as string)}</>,
    },
    {
        title: I18n.get('Succeeded At'),
        width: '1fr',
        render: (item: ReportRun) => <>{item.succeededAt ? formatTimestamp(item.succeededAt as unknown as string) : ''}</>,
    },
];

export const columns = getColumns();
